<template>
  <div class="h-100">
    <div v-if="!isVisibleRedeemCodeModal && !showPrakerjaFaceRecognition" class="activity-v2-layout h-100" :class="{ 'sidebar-open': isSidebarVisible }" @contextmenu.prevent>
      <div class="main h-100">
        <activity-header :class="hiddenNavigationClass" />
        <slot></slot>
      </div>
      <sidebar :class="hiddenNavigationClass" />
    </div>
    <page-skeleton v-else-if="isVisibleRedeemCodeModal || showPrakerjaFaceRecognition" />
    <input-redeem-code-prakerja @onSuccess="startLearning" />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import { mapState } from 'vuex'
import deviceDetector from 'mobile-device-detect'
import ActivityHeader from '@/components/activityV2/ActivityHeader'
import Sidebar from '@/components/activityV2/Sidebar'
import activityV2GeneralMixin from '@/mixins/activityV2/general'
import activityV2SidebarMixin from '@/mixins/activityV2SidebarMixin'
import prakerjaFaceRecognitionMixin from '@/mixins/activityV2/prakerjaFaceRecognition'
import { sendNetcore } from '@/functions/tracker/netcore'
const PageSkeleton = defineAsyncComponent(() => import('@/components/activityV2/PageSkeleton.vue'))
const InputRedeemCodePrakerja = defineAsyncComponent(() => import('@/components/activityV2/Modal/InputRedeemCodePrakerjaV2FlowRedeem.vue'))

export default {
  name: 'ActivityV2Layout',
  components: {
    ActivityHeader,
    Sidebar,
    PageSkeleton,
    InputRedeemCodePrakerja
  },
  data () {
    return {
      isMobile: deviceDetector.isMobile
    }
  },
  mixins: [activityV2GeneralMixin, activityV2SidebarMixin, prakerjaFaceRecognitionMixin],
  computed: {
    ...mapState('activityV2', ['isVisibleRedeemCodeModal']),
    domain () {
      return this.$store.state.hostDomain
    },
    hiddenNavigationClass () {
      return this.isAccessedFromKariermuB2bApp ? 'd-none' : ''
    }
  },
  methods: {
    startLearning () {
      this.$cookies.set('is-post-payment', true, '', '', this.domain)
      this.$store.dispatch('snackbar/showSnackbar', {
        allowMultiple: false,
        hasCloseBtn: true,
        isBottomPosition: this.isMobile,
        variant: 'success',
        text: 'Selamat! Program berhasil didapatkan.'
      }).then(result => {
        if (result.isConfirmed) this.initModalTour()
      })
    },
    getProgramStartedEventParams () {
      return {
        program_id: this.activityValidate?.program_id ?? 'NA',
        program_name: this.activityValidate?.program_name ?? 'NA',
        program_slug: this.activityValidate?.program_slug ?? 'NA',
        program_url: `https://${window.location.hostname}/program/${this.activityValidate?.program_slug}`,
        program_type: this.activityValidate?.purchase_type?.toLowerCase() === 'prakerja' ? 'prakerja' : 'nonprakerja',
        next_activity_slug: this.activityV2?.activityFocus?.resource_slug_after ?? 'NA',
        next_activity_name: this.activityV2?.activityFocus?.resource_slug_after ? this.activityV2?.activityFocus?.resource_slug_after?.replace(/-/g, ' ') : 'NA',
        total_activity: this.activityV2.setOfTopicResources && this.activityV2.setOfTopicResources.length > 0 ? parseInt(this.activityV2?.setOfTopicResources[0]) : 'NA',
        institution_id: this.activityValidate.creator_id || 'NA',
        institution_name: this.activityValidate.creator || 'NA',
        is_on_external_lms: String(this.activityValidate.is_external)
      }
    },
    logEvent (eventName, data) {
      sendNetcore(eventName, this.userInfo, data)
      window.firebaseAnalytics.logEvent(eventName, data)
    }
  },
  created () {
    this.$store.commit('activityV2/SET_IN_STUDY_PAGE_REVAMP', true)
  },
  mounted () {
    this.logActivityEvent('activity_view')

    if (this.$route.query.hasOwnProperty('program-started')) {
      this.logEvent('program_started', this.getProgramStartedEventParams())
    }
  },
  beforeUnmount () {
    this.$store.commit('activityV2/SET_IN_STUDY_PAGE_REVAMP', false)
    this.$store.commit('activityV2/TOGGLE_REDEEM_CODE_MODAL', false)
  }
}
</script>

<style scoped>
.activity-v2-layout {
  background-color: var(--color-neutral-400);
}

.main {
  -webkit-transition: width 0.3s ease-in-out;
  -o-transition: width 0.3s ease-in-out;
  transition: width 0.3s ease-in-out;
  width: 100%;
}

>>> .btn-toggle-activity-v2-sidebar {
  box-shadow: 0 2px 8px var(--color-medium-shadow);
  border-radius: 10px 0 0px 10px;
  padding: 0 16px;
  height: 40px;
  margin-top: 0;
}

>>> .btn-toggle-activity-v2-sidebar:hover {
  text-decoration: none;
}

.sidebar-open >>> .activity-v2-sidebar {
  right: 0;
}

@media (min-width: 992px) {
  .sidebar-open .main {
    width: calc(100% - 378px);
  }

  .sidebar-open >>> .activity-v2-navbar {
    width: calc(100% - 378px);
  }
}
</style>
